import type { AboutUs } from '../../types/api';
import { Button, Eyebrow, Reveal } from '../ui';
import { paragraphs } from '../../utils/text';

/** Bande anthracite: photo de l'entreprise à gauche, mission à droite. */
export default function MissionBand({ about }: { about: AboutUs | null }) {
  if (!about?.our_purpose) return null;
  const text = paragraphs(about.our_purpose).slice(0, 2);
  return (
    <section className="bg-charcoal text-white">
      <div className="grid lg:grid-cols-2">
        <div className="relative min-h-[20rem] overflow-hidden bg-secondary-700 lg:min-h-[32rem]">
          {about.image?.url && <img src={about.image.url} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />}
          <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-charcoal/60" />
        </div>
        <div className="flex items-center px-6 py-16 md:px-12 lg:px-20 lg:py-24">
          <Reveal className="max-w-xl">
            <Eyebrow tone="light" className="mb-4 lg:ml-0">Notre mission</Eyebrow>
            <h2 className="text-inherit font-display text-[2rem] font-bold normal-case leading-[1.1] tracking-normal md:text-[3rem]">Construire des infrastructures durables</h2>
            <div className="mt-6 space-y-4 text-[1.0625rem] leading-relaxed text-white/85">
              {text.map((p) => <p key={p.slice(0, 24)} className="!text-white/85">{p}</p>)}
            </div>
            <div className="mt-8"><Button to="/services" variant="light">Découvrir nos services</Button></div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
